import { useState, useEffect } from 'react';
import { Tooltip } from '@jobtarget/ui-library';
import Button from '../Button';
import { EASY_APPLY_TOOLTIP_MESSAGE } from '../../data/constants/constants';

interface JobItemProps {
  title: string;
  location: string;
  isActive: boolean;
  jobId?: number;
  onJobClick: () => void;
  onActionClick?: (jobId?: number) => void;
  actionButtonText: string;
  actionButtonVariant: 'outline-primary' | 'outline-danger' | 'transparent';
  isMockJob?: boolean;
  easyApplyEnabled?: boolean;
  relationshipManagerEmail?: string | null;
}

const JobItem = ({
  title,
  location,
  isActive,
  jobId,
  onJobClick,
  onActionClick,
  actionButtonText,
  actionButtonVariant,
  isMockJob = false,
  easyApplyEnabled,
  relationshipManagerEmail
}: JobItemProps) => {
  // Track window width for responsive behavior
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const isMobile = windowWidth < 768; // Standard breakpoint for mobile

  // Update window width when it changes
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  // Handler for action button click that passes the jobId
  const handleActionClick = () => {
    if (onActionClick) {
      onActionClick(jobId);
    }
  };

  return (
    <div style={{ 
      padding: isMobile ? '0.75rem' : '1rem',
      borderRadius: '4px',
      border: isMockJob ? '2px dashed #4caf50' : '1px solid #e9ecef',
      backgroundColor: isMockJob ? 'rgba(76, 175, 80, 0.05)' : 'transparent',
    }}>
      <div style={{ 
        display: 'flex', 
        flexDirection: isMobile ? 'column' : 'row',
        justifyContent: 'space-between',
        alignItems: isMobile ? 'flex-start' : 'center',
        gap: '0.75rem'
      }}>
        <div style={{ width: '100%' }}>
          <a 
            href="#" 
            style={{ 
              margin: 0,
              color: '#0d6efd',
              textDecoration: 'underline',
              fontSize: isMobile ? '1.1rem' : '1.25rem',
              fontWeight: 500,
              display: 'block',
              wordBreak: 'break-word'
            }}
            onClick={(e) => {
              e.preventDefault();
              onJobClick();
            }}
          >
            {isMockJob ? `🧪 ${title} (TEST)` : (title || 'No job title')}
          </a>
          <p style={{ margin: '0.25rem 0 0 0', fontWeight: 500 }}>{location.includes("null") ? "No location" : location}</p>
        </div>
        <div style={{
          display: 'flex',
          flexDirection: isMobile ? 'row' : 'row',
          alignItems: 'center',
          justifyContent: isMobile ? 'space-between' : 'flex-end',
          gap: isMobile ? '0.5rem' : '1rem',
          width: isMobile ? '100%' : 'auto',
          marginTop: isMobile ? '0.5rem' : 0
        }}>
          {/* <span style={{ 
            backgroundColor: isActive ? '#20c997' : '#6c757d',
            color: 'white',
            padding: '0.25rem 0.5rem',
            borderRadius: '4px',
            fontSize: '0.875rem',
            whiteSpace: 'nowrap'
          }}>
            {isActive ? 'Active' : 'Inactive'}
          </span> */}
          {easyApplyEnabled === false ? (
            <Tooltip
              message={(
                relationshipManagerEmail
                  ? <>{EASY_APPLY_TOOLTIP_MESSAGE} at <a href={`mailto:${relationshipManagerEmail}`}>{relationshipManagerEmail}</a></>
                  : <>{EASY_APPLY_TOOLTIP_MESSAGE}.</>
              ) as unknown as string}
              position="top"
              maxWidth={260}
              textAlign="center"
            >
              <Button
                text={actionButtonText}
                variant="outline-secondary"
                disabled
                id={`job-item-${actionButtonText}-button-${jobId}`}
                style={{ cursor: 'not-allowed' }}
              />
            </Tooltip>
          ) : (
            <Button
              text={actionButtonText}
              variant={actionButtonVariant}
              onClick={handleActionClick}
              id={`job-item-${actionButtonText}-button-${jobId}`}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export interface InterviewJobItemProps{
  title: string,
  location: string,
  reqId: string,
  jobId: string,
  created: string,
  status: string,
  onClick: () => void,
  isSelected?:boolean
}

const InterviewJobItem = ({ title, location, reqId, jobId, created, status, onClick, isSelected=false }: InterviewJobItemProps) => {
  const isMobile = window.innerWidth < 1000;

  useEffect(() => {
  }, [isMobile]);

  return (
    <>
      {/* Desktop View */}
      {!isMobile && (
        <div style={{
          display: 'flex',
          // backgroundColor: 'red'
        }}>
          {/* Left Item */}
          <div style={{
            // backgroundColor: 'red',
            width: '100%',
          }}>
            <div style={{
                display: 'flex',
                // gap: '25%'
              }}>
                {/* Job title and location */}
                <div style={{
                  // backgroundColor: 'blue',
                  // width: '100%',
                  minWidth: '30%',
                  maxWidth: '30%'
                }}>
                  <p 
                    style={{ 
                      margin: '0.75rem 0 0 0',
                      // color: '#0d6efd',
                      fontWeight: 500,
                      fontSize: '1.2rem',
                      color: 'black'
                    }}
                  >
                    {title}
                  </p>
                  <p style={{ 
                    margin: '0.25rem 0 0 0', 
                    // color: '#6c757d',
                    fontSize: '0.9rem',
                    fontWeight: 500
                  }}>
                    {location}
                  </p>
                </div>

                {/* Job Details */}
                <div style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '0.25rem',
                  color: 'black',
                  minWidth: '40%',
                  maxWidth: '40%',
                  overflow: 'hidden',
                  // backgroundColor: 'green',
                  // width: '100%',
                  // backgroundColor: 'red'  
                }}>
                  <span style={{
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap'
                  }}>
                    Req Id: {reqId}
                  </span>
                  <span>
                    Job Id: {jobId}
                  </span>
                  <span>
                    Created: {created}
                  </span>
                </div>

                <span className={`badge badge-${status === "Open" ? "success" : status === "Closed" ? "light" : "warning"}`}
                  style={{
                    padding: '0.5rem',
                    fontWeight: 500,
                    height: 'fit-content',
                    width: 'fit-content',
                    alignSelf: 'center',
                    // marginLeft: '1rem'
                  }}
                  >
                    {status}
                </span>
                <button className={`btn ${isSelected ? 'btn-outline-primary disabled' : 'btn-outline-primary'}`}
                  onClick={onClick}
                  disabled={isSelected}
                  style={{
                    padding: '0.8rem',
                    fontWeight: 500,
                    marginLeft: 'auto',
                    height: 'fit-content',
                    width: 'fit-content',
                    alignSelf: 'center',
                    cursor: isSelected ? 'not-allowed' : 'pointer'
                  }}
                >
                  {isSelected ? 'Selected' : 'Select'}
                </button>

            </div>
          </div>

          {/* Right Item */}
          {/* <div style={{
            // backgroundColor: 'blue',
            width: '50%',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '0.75rem'
          }}>
            
          </div> */}
        </div>
      )}

      {isMobile && (
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '1rem',
          padding: '1rem'
        }}>
          {/* Job title and location - Full width */}
          <div>
            <p 
              style={{ 
                margin: '0',
                fontWeight: 500,
                fontSize: '1.2rem',
                color: 'black'
              }}
            >
              {title}
            </p>
            <p style={{ 
              margin: '0.25rem 0 0 0', 
              fontSize: '0.9rem',
              fontWeight: 500,
              color: '#666'
            }}>
              {location}
            </p>
          </div>

          {/* Job Details - Column layout */}
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '0.25rem',
            color: '#666',
            fontSize: '0.875rem',
          }}>
            <span>Req Id: {reqId}</span>
            <span>Job Id: {jobId}</span>
            <span>Created: {created}</span>
          </div>

          {/* Status and Button - Row layout */}
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: '1rem'
          }}>
            <span className={`badge badge-success`}
              style={{
                padding: '0.5rem',
                fontWeight: 500,
                fontSize: '0.75rem'
              }}
              >
                {status}
            </span>
            <button className={`btn ${isSelected ? 'btn-outline-primary disabled' : 'btn-outline-primary'}`}
              onClick={onClick}
              disabled={isSelected}
              style={{
                padding: '0.5rem 1rem',
                fontWeight: 500,
                fontSize: '0.875rem',
                cursor: isSelected ? 'not-allowed' : 'pointer'
              }}
            >
              {isSelected ? 'Selected' : 'Select'}
            </button>
          </div>
        </div>
      )}
      
      <hr style={{
        borderTop: '1px solid #ebedf3',
        width: '100%',
        // backgroundColor: 'blue',
        margin: 0
      }}
      />
    </>
  )
}

export default JobItem; 
export { InterviewJobItem };